import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { AppService } from '../../../app.service';
import { ContentService } from '../../../services/content.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-team-member-blind-spots',
  templateUrl: './team-member-blind-spots.component.html',
  styleUrls: ['./team-member-blind-spots.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SafeHtmlPipe, CommonModule],
})
export class TeamMemberBlindSpotsComponent implements OnInit {
  @Input() mbtiType: string;
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(
    private appService: AppService,
    private contentService: ContentService,
  ) {}

  ngOnInit() {
    this.contentService.getReport('TeamsIndividualBlindSpots', this.mbtiType).subscribe((data) => {
      this.reportContent = data.content;
      this.isApiDataLoaded = true;
    });
  }
}
